var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"tw-mb-4 tw-text-gray-700"},[_c('SvgIcon',{staticClass:"tw-ml-1 tw-mr-2 tw-w-5 tw-h-5",staticStyle:{"margin-top":"-3px"},attrs:{"name":_vm.icon}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }